module.exports = __webpack_public_path__ + "static/media/real_review.bc926724.png";